export function handleImageSpecialCases(url : string){
    const matcher = /http(s?):\/\/((www\.)?)dropbox.com\/s\/([^.]*)\/([^.]*)\.([A-Za-z]+)((\?dl=[01])?)/
    console.log(`matching url ${url} with ${matcher}`);
    if (url.match(matcher))
    {
        console.log('match');
        if (!url.startsWith("https"))
        {
            url = url.replace("http://", "https://");
        }
        if (url.includes("?dl=") || url.includes('&dl='))
        {
            url = url.replace("?dl=0", "?dl=1").replace("&dl=0", "&dl=1");
        }
        else
        {
            if (url.includes('?'))
            {
                url = url + '&dl=1';
            }
            else
            {
                url = url + '?dl=1';
            }
        }
    }
    return url;
}